/**
 * Ícone de "casa" (endereço do restaurante) como data-URL SVG, para funcionar
 * igual no Google Maps (icon.url) e no Mapbox (background-image do marcador).
 */
export const CASA_TAMANHO = 36

const CASA_SVG =
    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='" +
    CASA_TAMANHO +
    "' height='" +
    CASA_TAMANHO +
    "'>" +
    "<path d='M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' fill='#1565c0' stroke='#ffffff' stroke-width='1.2' stroke-linejoin='round'/>" +
    "</svg>"

export const CASA_SVG_DATA_URL = "data:image/svg+xml," + encodeURIComponent(CASA_SVG)
